import { clientRender } from '@vzmi/iso-redux'
import { setupServiceEndpoint } from 'reservice'

import appConf from '../../conf/appConf'
import configureStore from './configureStore'
import rootReducer from './reducers/index'
import MainComponent from './containers/App'
import communicators from './middlewares/index'

setupServiceEndpoint(appConf.reserviceUrlPath) // reservice url path

// @vzmi/iso-redux will call initStore to create redux store with preloaded state
export const initStore = (preloadedState) => {
  const hotReloadName = preloadedState
  const middlewares = Array.isArray(communicators)
    ? communicators
    : [communicators]

  const store = configureStore({
    rootReducer,
    preloadedState,
    middlewares,
    hotReloadName
  })

  return store
}

// client side render main
clientRender({
  mainComponent: MainComponent,
  configureStore: initStore
})

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept()
}
